import  { COMMISSION } from "../actions/types"

const initialize = { history: [] }

const commissionReducer = (state = initialize, {type, payload}) => {
    switch (type) {
        case COMMISSION.FETCH_COMMISSION_SUCCESS:
            return {...state, history: payload}
    
        default:
            return state
    }
}

export default commissionReducer;